export const ONLINE_KEY = {
  SEARCH_INPUT_LABEL: 'Zoek Online Keys',
  SEARCH_INPUT_PLACEHOLDER: 'Zoek Online Keys',
  SEARCH_INPUT_ALT: 'Zoek Online Keys door tekst in te voeren',
  SEARCH_INPUT_REQUIRED_ERROR: 'Zoekterm is vereist!',
  SEARCH_INPUT_NO_ITEMS_FOUND_ERROR: 'Geen overeenkomsten gevonden!',
};
